export const C = {
  bg:        '#f4f7f4',
  surface:   '#ffffff',
  card:      '#ffffff',
  cardHover: '#eef7f0',
  border:    '#c8e6d0',
  accent:    '#16a34a',
  accentSoft:'#dcfce7',
  gold:      '#16a34a',
  emerald:   '#22c55e',
  rose:      '#ef4444',
  amber:     '#d97706',
  text:      '#0a0f0a',
  muted:     '#3d5245',
  dim:       '#8aab96',
};

// ─── Traductions françaises ─────────────────────────────────────────────────
export const FR = {
  roles: {
    player:              'Joueur',
    coach:               'Entraîneur',
    manager:             'Manager',
    president:           'Président',
    directeur:           'Directeur',
    medical_staff:       'Staff médical',
    entityPlatformAdmin: 'Admin plateforme',
    direction_statff:    'Direction',
  },
  status: {
    active:    'Actif',
    open:      'Ouvert',
    completed: 'Terminé',
    cancelled: 'Annulé',
    draft:     'Brouillon',
    close:     'Clôturé',
    review:    'En révision',
  },
  eventType: {
    tournament:  'Tournoi',
    single_game: 'Match unique',
    training:    'Entraînement',
    trial:       'Essai',
  },
  entityType: {
    club:                 'Club',
    academy:              'Académie',
    football_association: 'Association',
  },
};

export const tRole   = (r) => FR.roles[r]      || r?.replace(/_/g, ' ') || '—';
export const tStatus = (s) => FR.status[s]     || s || '—';
export const tEType  = (t) => FR.eventType[t]  || t?.replace(/_/g, ' ') || '—';
export const tEntity = (t) => FR.entityType[t] || t?.replace(/_/g, ' ') || '—';

// ─── Position labels (full names) ───────────────────────────────────────────
export const POSITION_LABELS = {
  GK:  'Gardien',
  CB:  'Défenseur central',
  RB:  'Arrière droit',
  LB:  'Arrière gauche',
  RWB: 'Piston droit',
  LWB: 'Piston gauche',
  SW:  'Libéro',
  CDM: 'Milieu défensif',
  CM:  'Milieu central',
  CAM: 'Milieu offensif',
  RM:  'Milieu droit',
  LM:  'Milieu gauche',
  RW:  'Ailier droit',
  LW:  'Ailier gauche',
  CF:  'Avant-centre',
  ST:  'Attaquant',
};

// ─── CSS injection ───────────────────────────────────────────────────────────
export const injectStyles = () => {
  if (document.getElementById('ed-styles')) return;
  const style = document.createElement('style');
  style.id = 'ed-styles';
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

    * { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }

    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(24px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes scaleIn {
      from { opacity: 0; transform: scale(0.88); }
      to   { opacity: 1; transform: scale(1); }
    }
    @keyframes pulse {
      0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.3); }
      50%       { box-shadow: 0 0 0 10px rgba(34,197,94,0); }
    }
    @keyframes pulseRose {
      0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.35); }
      50%       { box-shadow: 0 0 0 10px rgba(239,68,68,0); }
    }
    @keyframes countUp {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .ed-card {
      transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
      border: 1px solid #c8e6d0 !important;
      font-family: 'Plus Jakarta Sans', sans-serif !important;
    }
    .ed-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(34,197,94,.13) !important;
      background: #eef7f0 !important;
    }
  `;
  document.head.appendChild(style);
};